<template>
  <div class="dashboard">
    <h1>欢迎进入篱笆教育后台</h1>
  </div>
</template>

<script>

export default {
  name: 'dashboard',
}
</script>

<style lang="scss">
.row-equal .flex {
  .va-card {
    height: 100%;
  }
}

.dashboard {
  .va-card {
    margin-bottom: 0 !important;
  }
}
</style>
